module.exports = __webpack_public_path__ + "img/marketo.7ef74fb0.svg";